import { render, staticRenderFns } from "./SeatInfo.vue?vue&type=template&id=c7bf70c4&scoped=true&"
import script from "./SeatInfo.vue?vue&type=script&lang=ts&"
export * from "./SeatInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SeatInfo.vue?vue&type=style&index=0&id=c7bf70c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bf70c4",
  null
  
)

export default component.exports